export const FETCH_COMMENTS = 'event/annualReport/FETCH_COMMENTS';
export const POST_COMMENT = 'event/annualReport/POST_COMMENT';

export const PREPEND_COMMENT = 'event/annualReport/PREPEND_COMMENT';



// WEBPACK FOOTER //
// ./src/app/redux/events/annualReport/types.js